import { z } from "zod";

export const ConsumerLookupSchema = z.object({
  id: z.number().int(),
  consumerKey: z.string(),
  consumerName: z.string(),
});

export const RequestTypeLookupSchema = z.object({
  id: z.number().int(),
  requestTypeKey: z.string(),
  requestTypeName: z.string(),
});

export const DocumentTypeLookupSchema = z.object({
  id: z.number().int(),
  typeName: z.string(),
  typeKey: z.string(),
});

export const RequestStatusLookupSchema = z.object({
  id: z.number().int(),
  statusKey: z.string(),
  statusName: z.string(),
});

/** Same shape as request statuses; used by Stranger Files filter lookup. */
export const StrangerFileStatusLookupSchema = RequestStatusLookupSchema;

export const ModelLookupSchema = z.object({
  id: z.number().int(),
  modelKey: z.string(),
  modelName: z.string(),
});

export type ConsumerLookup = z.infer<typeof ConsumerLookupSchema>;
export type RequestTypeLookup = z.infer<typeof RequestTypeLookupSchema>;
export type DocumentTypeLookup = z.infer<typeof DocumentTypeLookupSchema>;
export type RequestStatusLookup = z.infer<typeof RequestStatusLookupSchema>;
export type StrangerFileStatusLookup = z.infer<typeof StrangerFileStatusLookupSchema>;
export type ModelLookup = z.infer<typeof ModelLookupSchema>;
